<template>
    <div>
        <complete-physician-profile></complete-physician-profile>

        <common-content-wrapper width="large">
            <common-content-spacer height="medium">
                <common-page-header
                    :heading="$t('pages.auth.signup.steps.register_physicians.form.heading')"
                    size="small"
                ></common-page-header>

                <import-contacts
                    :sendButtonLabel="
                        $t('pages.auth.signup.steps.register_physicians.modals.import_contacts_modal.send_button_label')
                    "
                    :showSearchBar="true"
                    @contacts-emails-collected="collectContactsEmails"
                ></import-contacts>

                <email-collector
                    :label="$t('pages.auth.signup.steps.register_physicians.form.field_label')"
                    :placeholder="$t('pages.auth.signup.steps.register_physicians.form.field_placeholder')"
                    :buttonLabel="$t('pages.auth.signup.steps.register_physicians.form.button_label')"
                    :initialNumOfFields="initialNumOfFields"
                    :formData="formDataEmailFields"
                    :valuePath="'emailFields'"
                    @emails-collected="emailsCollected"
                    @change="emailsChanged"
                ></email-collector>

                <common-modal
                    v-if="showEmailsCheckModal"
                    :width="'medium'"
                    @emitEvent="emitEvent($event, ['close'])"
                    @close="emitEvent({ name: 'close' })"
                >
                    <send-join-invites-overview
                        :emailsCheck="emailsCheck"
                        :practiceType="practiceType"
                        :defaultCloseButtonEnabled="false"
                        :innerButtonsProperties="[
                            {
                                label: $t('pages.auth.signup.steps.register_physicians.modals.invite_email_check.button_1_label'),
                                type: 'white-with-border',
                                size: 'large',
                                isSubmittable: false,
                                eventName: 'invite-other-physicians-to-practice',
                            },
                            {
                                label: $t('pages.auth.signup.steps.register_physicians.modals.invite_email_check.button_2_label'),
                                type: 'primary',
                                size: 'large',
                                isSubmittable: false,
                                eventName: 'continue-physician-registration',
                            },
                        ]"
                        @new-email-invitations-present="sendInvitationsToPhysicians"
                        @invite-other-physicians-to-practice="clearEmailFormFields"
                        @continue-physician-registration="emitEvent({ name: 'next-step' })"
                        @close="checkInviteEmailsModalClosedHandler"
                    ></send-join-invites-overview>
                </common-modal>
            </common-content-spacer>
        </common-content-wrapper>
    </div>
</template>

<script>
    import CompletePhysicianProfile from 'components/page-elements/auth/register-physicians/CompletePhysicianProfile'
    import SendJoinInvitesOverview from 'components/page-elements/invites/SendJoinInvitesOverview'
    import EmailCollector from '../network/EmailCollector'
    import SignupPageMixin from '../../../mixins/SignupPageMixin'
    import InvitationEmailCheckModalMixin from '../../../mixins/InvitationEmailCheckModalMixin'
    import UsersAPI from 'api/UsersAPI'
    import UserRolesEnum from '../../../enums/UserRolesEnum'
    import ImportContacts from '../invites/ImportContacts'

    export default {
        mixins: [SignupPageMixin, InvitationEmailCheckModalMixin],

        components: {
            CompletePhysicianProfile,
            SendJoinInvitesOverview,
            EmailCollector,
            ImportContacts,
        },

        data() {
            return {
                practiceType: this.$t('pages.auth.signup.steps.register_physicians.constants.practice_type'),
            }
        },

        methods: {
            collectContactsEmails(conctactsEmails) {
                conctactsEmails.forEach((item) => {
                    item.emails.forEach((el) => {
                        this.sourceEmailFields.push({
                            email: el.email,
                            firstName: item.firstName,
                            lastName: item.lastName,
                        })
                    })
                })
                this.sourceEmailFields = this.sourceEmailFields.filter((emailFieds) => emailFieds.email !== '')
            },
            sendInvitationsToPhysicians(event) {
                UsersAPI.createJoinPracticeInvites({
                    userId: this.$auth.getActiveMember().id,
                    emails: event.emails,
                    practiceId: this.$auth.getPractice().id,
                    userRoleId: UserRolesEnum.PHYSICIAN.ID,
                }).then(() => {})
            },
        },
    }
</script>

<style scoped>
    .email-collector >>> input[type='email'] {
        width: 29.5rem;
    }
</style>
